import { useState } from "react";
import dayjs from "dayjs";
import { atualizarReservaService } from "../../../services/atualizarReservaService";
import { buscarReservaService } from "../../../services/buscarReservaByIdService";

export const useConfirmarPagamentoMC = (
  reservaId: number | null,
  dataRecebimentoMC: any
) => {
  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const [successMessage, setSuccessMessage] = useState<string | null>(null);

  const atualizar = async () => {
    setErrorMessage(null); // Resetando mensagem de erro antes de tentar novamente
    setIsLoading(true);
    let dataReserva = {};

    try {
      const reserva = await buscarReservaService(reservaId);

      if (reserva) {
        dataReserva = {
          statusReserva: reserva.dataPagamentoProprietario
            ? "FINALIZADO"
            : null,
          dataRecebimentoMC: dataRecebimentoMC
            ? dayjs(dataRecebimentoMC.dataRecebimentoMC).format(
                "YYYY-MM-DD HH:mm:ss"
              )
            : null,
        };
      }

      // Se o serviço de atualização falhar, pode atualizar o erro
      // Caso o `atualizarReserva` retorne um valor falso, exibe um erro
      const atualizarReserva = await atualizarReservaService(
        reservaId,
        dataReserva
      );
      if (!atualizarReserva) {
        setErrorMessage(
          "Não foi possível confirmar Data de Recebimento. Tente novamente!"
        );
      } else {
        // Caso contrário, pode ser sucesso, se o retorno for esperado
        setSuccessMessage("Data de Recebimento confirmada com sucesso.");
      }
    } catch (error) {
      // Captura erros inesperados
      setErrorMessage(
        "Erro ao atualizar a Data de Recebimento. Tente novamente!"
      );
    } finally {
      setIsLoading(false); // Garantir que o loading seja removido ao final
    }
  };

  return { atualizar, isLoading, errorMessage, successMessage };
};
